import { render, staticRenderFns } from "./trusteeshipList.vue?vue&type=template&id=6b8f7e6a&scoped=true"
import script from "./trusteeshipList.vue?vue&type=script&lang=js"
export * from "./trusteeshipList.vue?vue&type=script&lang=js"
import style0 from "./trusteeshipList.vue?vue&type=style&index=0&id=6b8f7e6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8f7e6a",
  null
  
)

export default component.exports